<form class="geaui-grid-col-12">
  <div class="dialog-body mb-6">
    You are overriding a file with the same name!<br />
    Would you like to replace the file instead?
  </div>
  <p-divider />
  <div class="p-dialog-footer">
    <geaui-button-v3 [type]="'secondary'" (click)="reject()">No</geaui-button-v3>
    <geaui-button-v3 (click)="confirm()">Yes</geaui-button-v3>
  </div>
</form>
